export const cilMusicNote = ["24 24","<path d='M3.375 9.54l7.5-1.5v9.828c0 0.044 0 0.088 0 0.132 0 2.615 2.271 4.743 5.063 4.743s5.063-2.128 5.063-4.743-2.271-4.743-5.063-4.743c-0.008-0-0.018-0-0.028-0-1.365 0-2.607 0.523-3.538 1.38l0.004-0.003v-13.298l-9 1.8zM15.938 14.757c1.965 0 3.563 1.453 3.563 3.243s-1.598 3.243-3.563 3.243-3.563-1.453-3.563-3.243 1.598-3.243 3.563-3.243zM4.875 4.365l6-1.2v3.345l-6 1.2z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-music-note.js
// module id = null
// module chunks = 